@if (chunkCount() && isLoading()) {
  <lib-tile-loader @fadeOut [count]="chunkCount()"/>
}
@if (sortedDataChunks(); as dataChunks) {
  <lib-cubes-manager
    data-test="tile-grid"
    [dataModel]="dataChunks"
  >
    <lib-cube
      class="tile"
      data-test="tile"
      *cubeTemplate="dataChunks; let dataChunk"
      [attr.data-is-total]="dataChunk.isTotal"
    >
      @let focusDataPoint = dataChunk.dataPoints | getDataPoint: focusParams();
      @let growthDataPoint = dataChunk.dataPoints | getDataPoint: growthParams();

      <ng-template #header>
        <lib-tile-header [title]="dataChunk.dimensionItems | dataChunkTitle: dimensionLevelName()"/>
      </ng-template>

      <div
        *libCubeFace
        class="tile-face"
        [attr.data-sentiment]="focusDataPoint | highlightSentiment: highlightedIds()"
      >
        <header class="tile-header">
          <ng-template [ngTemplateOutlet]="header"/>
          <lib-direction-indicator [value]="focusDataPoint?.sentiment"/>
        </header>

        <lib-featured-value
          [value]="focusDataPoint?.value"
          [measure]="focusMeasure()"
          [growthValue]="growthDataPoint?.value"
          [growthMeasure]="growthMeasure()"
          [growthMeasureLabel]="growthMeasureLabel()"
        />

        @switch (tileDisplay()) {
          @case (TileDisplay.Table) {
            @if (tableLayout(); as layout) {
              <lib-data-table
                [dataPoints]="dataChunk.dataPoints"
                [layout]="layout"
              />
            }
          }
          @case (TileDisplay.Trends) {
              <lib-l12m-bar-chart
                [dataPoints]="dataChunk.dataPoints"
                [growthMeasure]="growthMeasure()"
                [period]="focusPeriod()"
                [date]="focusDate()"
                [title]="focusMeasure()?.shortName + ' change vs previous year'"
                [range]="valueRange()"
                [isHighlighted]="focusDataPoint | dataPointMatch : highlightedIds()"
              />
          }
        }
      </div>

      <div
        *libCubeFace
        class="tile-face"
        [attr.data-sentiment]="focusDataPoint?.sentiment"
      >
        <ng-template [ngTemplateOutlet]="header"/>

        @if (perspective(); as perspective) {
          @if (totalPerspective(); as totalPerspective) {
            <lib-report-button
              [perspective]="dataChunk.isTotal ? totalPerspective : perspective"
              [filterDimensions]="dataChunk.dimensionItems"
              [options]="{
              focusMeasure: focusMeasure(),
              focusPeriod: focusPeriod()
            }"
              [reportPath]="reportPath()"
            />
          }
        }

        <lib-drilldown
          [dimensionItems]="dataChunk.dimensionItems"
          (drillDown)="handleDrilldown($event)"
        />
      </div>
    </lib-cube>
  </lib-cubes-manager>
}
